import api from "@/apis/notifications/notificationsAPI";
import Crud from "@/stores/crud-base";

const crud = new Crud("notifications", api);

const state = {
  ...crud.state,

  notifications: [],
  totalNotiNew: 0,
  totalNotification: 0,
  notificationsParam: {
    maxResultCount: 10,
    skipCount: 0,
  },
  isGettingNotificaitons: false,
};

const getters = {
  ...crud.getters,
  totalNotiNew(state) {
    return state.totalNotiNew;
  },
};

const actions = {
  ...crud.actions,

  async getNotifications(context, payload) {
    if (payload?.isInit) {
      context.commit("updateLoading", true);
      context.commit("resetState");
    }

    let res = null;

    try {
      context.commit("updateGettingNotification", true);
      res = await api.getNotifications(payload);
    } finally {
      context.commit("updateGettingNotification", false);
      if (payload?.isInit) {
        context.commit("updateLoading", false);
      }
    }

    if (!res.error) {
      if (payload.isNewNotification) {
        context.commit("prependNewNotification", res);
      } else {
        context.commit("handleUpdateNotifications", res);
      }
      return res;
    }
  },
  async maskReaded(context, payload) {
    // Đánh dấu đã đọc tất cả noti
    if (payload.notiIds && payload.notiIds.length == 0) {
      context.commit("handleReadedAllNoti");
    }
    api.maskReadedNoti(payload);
  },

  async maskViewed(context, payload) {
    //Đánh dấu xem noti-
    context.commit("resetTotalNotiNew"); //reset-state
    await api.maskViewed(payload); //gọi api đánh dấu đã xem
  },
};

const mutations = {
  ...crud.mutations,

  updateGettingNotification(state, data) {
    state.isGettingNotificaitons = data;
  },

  /**
   * Reset lại state noti
   */
  resetState(state) {
    state.notifications = [];
    state.totalNotification = 0;
  },

  updateNotificationParams(state, data) {
    state.notificationsParam = {
      maxResultCount: data.maxResultCount ?? 10,
      skipCount: data.skipCount ?? 0,
    };
  },

  handleUpdateNotifications(state, data) {
    var notifications = [];
    var isNeedBuildTitle = true;
    var isLoadMore = state.notificationsParam.skipCount > 0;

    if (data.items) {
      // Build dữ liệu
      var todayItem = null; // section hôm nay
      var otherDayItem = null; // section trước đó
      const currentDate = new Date();
      // current date
      const day = currentDate.getDate();
      const month = currentDate.getMonth() + 1; // Note: Month is zero-based (0 = January)
      const year = currentDate.getFullYear();

      // Lấy thêm dữ liệu thì check xem có item section trước đó hay chưa?
      if (isLoadMore) {
        otherDayItem = state.notifications.find((x) => x.date == "Trước đó");
        todayItem = state.notifications.find((x) => x.date == "Hôm nay");
      }

      data.items.forEach((element) => {
        // Build dữ liệu thành 2 section: Hôm nay và trước đó
        let isNotiToday =
          day == element.createdDate?.getDate() &&
          month == element.createdDate?.getMonth() + 1 &&
          year == element.createdDate?.getFullYear();

        if (!otherDayItem) {
          // Build title cho ngày "hôm nay"
          if (isNotiToday && !todayItem) {
            todayItem = {
              isTimeCell: true,
              date: "Hôm nay",
            };
            notifications.push(todayItem);
          } else if (!isNotiToday && !otherDayItem) {
            otherDayItem = {
              isTimeCell: true,
              date: "Trước đó",
            };
            notifications.push(otherDayItem);
          }
        }

        var item = {
          isTimeCell: false,
          notification: element,
        };
        notifications.push(item);
      });
    }
    // Loadmore thì add thêm dữ liệu
    if (state.notificationsParam.skipCount > 0) {
      let fullNotis = state.notifications.concat(notifications);
      state.notifications = fullNotis;
    } else {
      state.notifications = notifications;
    }

    state.totalNotiNew = data.totalNotiNew;
    state.totalNotification = data.totalCount;
  },

  handleReadedAllNoti(state, data) {
    let notifications = state.notifications;
    notifications.forEach((element) => {
      if (element.notification) {
        element.notification.readAt = new Date();
      }
    });
    state.notifications = notifications;
  },

  resetTotalNotiNew(state, data) {
    state.totalNotiNew = 0;
  },

  prependNewNotification(state, data) {
    if (!data.items || data.items.length === 0) return;

    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();

    // Kiểm tra notification mới có phải là của hôm nay
    const newNoti = data.items[0];
    const createdDate = new Date(newNoti.createdDate);
    const isNotiToday =
      createdDate.getDate() === day &&
      createdDate.getMonth() + 1 === month &&
      createdDate.getFullYear() === year;

    let notifications = [...state.notifications];

    if (isNotiToday) {
      // Tìm section "Hôm nay"
      const todayIndex = notifications.findIndex((x) => x.isTimeCell && x.date === "Hôm nay");

      if (todayIndex >= 0) {
        // Chèn notification mới vào sau title "Hôm nay"
        notifications.splice(todayIndex + 1, 0, {
          isTimeCell: false,
          notification: newNoti,
        });
      } else {
        // Chưa có section "Hôm nay" thì thêm vào đầu
        notifications.unshift(
          { isTimeCell: true, date: "Hôm nay" },
          { isTimeCell: false, notification: newNoti },
        );
      }
    } else {
      // Tìm section "Trước đó"
      const otherDayIndex = notifications.findIndex((x) => x.isTimeCell && x.date === "Trước đó");

      if (otherDayIndex >= 0) {
        // Chèn vào sau title "Trước đó"
        notifications.splice(otherDayIndex + 1, 0, {
          isTimeCell: false,
          notification: newNoti,
        });
      } else {
        // Chưa có section "Trước đó"
        const insertIndex = notifications.length > 0 ? notifications.length : 0;
        notifications.splice(
          insertIndex,
          0,
          { isTimeCell: true, date: "Trước đó" },
          { isTimeCell: false, notification: newNoti },
        );
      }
    }

    state.notifications = notifications;
    state.totalNotiNew = data.totalNotiNew;
    state.totalNotification = data.totalCount;
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
